import { render } from "./KynHeroProfile.vue?vue&type=template&id=130168e2"
import script from "./KynHeroProfile.vue?vue&type=script&lang=js"
export * from "./KynHeroProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__